import * as React from "react"
import { observer } from "mobx-react"
import { WaiverMembersCard } from "./WaiverMembersCard"
import { WaiversStep } from "./WaiversStep"

@observer
export class WaiversStepComp extends React.Component<{
  model: WaiversStep
}> {
  render() {
    const { model } = this.props
    const children: any = []
    children.push(
      <div
        key={0}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: window.innerWidth > 450 ? 30 : 0,
          width: "100%"
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            marginBottom: 30
          }}
        />
        {model.waiverEditors.map((waiverEditor, i) => (
          <WaiverMembersCard key={i} model={waiverEditor} />
        ))}
        {/* <Button
          pay
          style={{ marginRight: 10, marginTop: 20 }}
          className="button"
          onClick={model.addWaiver}
        >
          <span className="icon is-small" style={{ marginRight: 10 }}>
            <i className="fas fa-plus" />
          </span>
          <span />
          Add Another Waiver
        </Button> */}
      </div>
    )

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          marginTop: window.innerWidth > 450 ? 20 : 0
        }}
      >
        {children}
      </div>
    )
  }
}
